import {types} from '../actions/types';

const initialState = {
  loading: false,
  data: {},
  error: {},
};

const complaintReducer = (state = initialState, {type, payload}) => {
  switch (type) {
    case types.SEND_REQUEST_SAVE_COMPLAINT:
      return {
        ...state,
        loading: true,
      };
    case types.SEND_REQUEST_SAVE_COMPLAINT_SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false,
      };
    case types.SEND_REQUEST_SAVE_COMPLAINT_FAILURE:
      return {
        ...state,
        data: {},
        error: payload,
        loading: false,
      };
      case types.CLEAR_REQUEST_SAVE_COMPLAINT:
        return {
          ...state,
          data: {},
          loading: false,
        };
    default:
      return state;
  }
};

export default complaintReducer;
